import Slider from './slider';
import config from '../config';

const { breakpoints } = config;

export default class ProductsSlider extends Slider {
    constructor({ node }) {
        const $slider = node;

        super({
            node: $slider,
            appendDots: $slider.find('.slider__dots'),
            responsive: [
                {
                    breakpoint: breakpoints.lg,
                    settings: {
                        dots: false
                    }
                }
            ]
        });

        this.$sliderCountsEl = this.$slider.find('.slider__counts');
        this.slideLength = 0;

        this.init();
    }

    changeViewNumb(slideNumber) {
        this.$sliderCountsEl.html(`<span class="slider__current-numb">${slideNumber}</span><span class="slider__sum">${this.slideLength}</span>`);
    }

    init() {
        const that = this;

        this.$sliderContainer
            .on('init', (e, slick) => {
                that.slideLength = slick.slideCount;
                that.changeViewNumb(slick.slickCurrentSlide() + 1);
            })
            .on('afterChange', (e, slick) => {
                const currentSlide = slick.slickCurrentSlide() + 1;
                that.changeViewNumb(currentSlide);
            });

        super.init();
    }
}




// WEBPACK FOOTER //
// ./components/interiorsSlider.js